<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="编号">
              <a-input v-model="queryParam.number" placeholder=""/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="批次">
              <a-input v-model="queryParam.batch" placeholder=""/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd" v-action:add>新建</a-button>
      <a-button type="primary" @click="water_bill_c">生成水费账单</a-button>
    </div>

    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="count_render" slot-scope="text" style="text-align: right; min-width: 100px; max-width: 110px">
        {{ text }}
      </div>
      <div slot="money_render" slot-scope="text" style="text-align: right; min-width: 100px; max-width: 110px">
        {{ (text / 100).toFixed(2) | numberFormat }}
      </div>
      <span slot="color" slot-scope="color">
        <a-tag
          style="height: 15px"
          :color="color"
        >
          {{ '    ' }}
        </a-tag>
      </span>
      <span slot="action" slot-scope="text, record" v-action:delete>
        <template>
          <a-popconfirm
            v-if="record.water_bill_id === -1"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelet(record)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <a-modal
      title="生成水费账单"
      v-if="billvisble"
      :width="880"
      :visible="billvisble"
      :confirm-loading="billLoading"
      :footer="null"
      @cancel="handleBillCancel"
    >
      <a-form-model
        ref="ruleForm"
        :rules="rules"
        style="width: 100%"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :model="form"
      >
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-model-item label="批次" style="width: 100%" prop="batch">
              <a-input v-model="form.batch" />
            </a-form-model-item>
          </a-col>
          <a-col :md="14" :sm="24">
            <a-form-item label="日期">
              <a-range-picker @change="time" format="YYYY-MM-DD" style="width: 100%">
                <template slot="dateRender" slot-scope="current">
                  <div class="ant-calendar-date" :style="getCurrentStyle(current)" >
                    {{ current.date() }}
                  </div>
                </template>
              </a-range-picker>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form-model>
      <a-button type="primary" @click="handleWaterOk">生成水费账单</a-button>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { STable } from '@/components'
import { water_meter_record_create, water_meter_record_delete, water_meter_record_list } from '@/api/water_meter'
import { Dictionaries } from '@/common/AllConstant'
import CreateForm from '../modules/RecordCreateForm'
import { water_bill_create } from '@/api/water'
import { getForms, createProcessResult } from '@/api/oa_approve'
import { getValueByKey } from '@/utils/util'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm
  },
  data () {
    return {
      rules: {
        batch: [
          { required: true, message: '请输入', trigger: 'blur' }
        ]
      },
      form: {
        batch: '',
        start_date: '',
        end_date: ''
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
      billLoading: false,
      billvisble: false,
      loading: false,
      confirmLoading: false,
      dictionaries: Dictionaries,
      // 创建窗口控制
      visible: false,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '水表编号',
          dataIndex: 'water_meter_number',
          ellipsis: true
        },
        {
          title: '企业',
          dataIndex: 'corporation',
          ellipsis: true
        },
        {
          title: '上期表读数',
          dataIndex: 'last_value',
          scopedSlots: { customRender: 'count_render' },
          align: 'center'
        },
        {
          title: '表读数',
          dataIndex: 'value',
          scopedSlots: { customRender: 'count_render' },
          align: 'center'
        },
        {
          title: '单价',
          dataIndex: 'price',
          scopedSlots: { customRender: 'money_render' },
          align: 'center'
        },
        {
          title: '总价',
          dataIndex: 'amount',
          scopedSlots: { customRender: 'money_render' },
          align: 'center'
        },
        {
          title: '关联状态',
          dataIndex: 'water_bill_id',
          customRender: (text) => text > 0 ? ' 已关联' : '未关联'
        },
        {
          title: '批次',
          dataIndex: 'batch',
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData.parameter', parameter)
        return water_meter_record_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            console.log(res.data, '我是数据列表@')
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    console.log(this.$Dictionaries)
  },
  methods: {
    // 按照时间创建租金账单
    handleWaterOk () {
      if (!this.form.batch) {
        this.$message.error('表单不能为空')
        return
      }
      // const param = Object.assign({}, { ...this.form })
      water_bill_create({ ...this.form }).then((res) => {
        console.log(res)
        if (res.success) {
          this.$message.success('本次生成' + res.data.length + '条账单')
          this.$refs.table.refresh()
          this.createShenPi(res.data.ids)
        }
        this.billvisble = false
        this.billLoading = false
          this.form.batch = ''
          this.form.start_date = ''
          this.form.end_date = ''
      })
    },
    handleBillCancel () {
      this.billvisble = false
      this.billLoading = false
    },
    water_bill_c () {
      this.billvisble = true
    },
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      this.mdl = null
      this.visible = true
    },
    handleAddCancel () {
      this.visible = false

      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleEdit (record) {
      this.$emit('onEdit', record)
    },
    handleDelet (record) {
      water_meter_record_delete(record.id).then((res) => {
        console.log(res)
        console.log('删除成功------')
        this.$refs.table.refresh()
      })
    },
    handleOk () {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          var res = values.data
          res = res.replace('，', ',')
          res = res.split('\n')
          res = res.map((item) => {
            return item.split(',')
          })
          values.data = res
          console.log(res, '我是切分的数组')
          // 新增
          water_meter_record_create(values).then(res => {
              this.visible = false
              this.confirmLoading = false
              // 重置表单数据
              form.resetFields()
              // 刷新表格
              this.$refs.table.refresh()

            console.log('删除成功------')
            })
        } else {
          this.confirmLoading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },

    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    },
    time (dates, dateStrings) {
      console.log(dateStrings, '时间')
      this.form.start_date = dateStrings[0]
      this.form.end_date = dateStrings[1]
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    },
    createShenPi (ids, type = 'water_bill') {
      const typeValue = getValueByKey(type, this.$Dictionaries.approval_category)
      let typeCategory
      if (typeValue === undefined) {
        this.$message.warning('没有对应的审批')
        return
      } else if (Array.isArray(typeValue)) {
        typeCategory = typeValue.join(',')
      }
      if (typeCategory === undefined) {
        this.$message.warning('没有对应的审批')
        return
      }
      getForms({ is_stop: 0, category: typeCategory }).then(res => {
        console.log(res)
        const shenpi_list = res.data.entries
        if (shenpi_list && shenpi_list.length > 0) {
          for (let i = 0, len = shenpi_list.length; i < len; i++) {
            const item = shenpi_list[i]
            if (item.category === typeCategory) {
              this.createProcessNotice(item.id, ids, typeCategory, false)
              break
            }
          }
        } else {
          this.$message.error('先创建审批模板')
        }
      })
    },
    createProcessNotice (template_id, ids, type) {
      for (const id in ids) {
        const data = {
          'data_id': id,
          'template_id': template_id,
          'category': type,
          'approval_again': false
        }
        createProcessResult(data).then(res => {
          console.log(res)
          if (res.code === 1000) {
            console.log('创建成功')
          }
        })
      }
    }
  }
}
</script>
